module.exports = __webpack_public_path__ + "static/media/DSC_0092.1499d08a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0092.jpg
// module id = 631
// module chunks = 0